module.exports = __webpack_public_path__ + "static/media/operators.fc9bd592.png";